import React from 'react';
import { touchedCells } from '@/components/planning/planningSync';

const download = (schedules) => {
  const cells = touchedCells(schedules).map(({ date, userId, cell }) => {
    const { _server, ...rest } = cell;
    return { date, user_id: userId, ...rest };
  });
  const blob = new Blob([JSON.stringify({ exported_at: new Date().toISOString(), cells }, null, 2)], { type: 'application/json' });
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'planning_saisies_non_enregistrees.json'; a.click();
};

// Session perdue (expirée ou même compte ouvert ailleurs) : saisies gardées en mémoire et sur l'appareil.
export const SessionLostBanner = ({ pending, schedules, onRetry, onDismiss }) => (
  <div className="mb-3 rounded-lg border-2 border-red-400 bg-red-50 px-4 py-3 text-sm text-red-900" role="alert" data-testid="planning-session-lost">
    <p className="font-semibold">Vous avez été déconnecté : session expirée ou même compte ouvert sur un autre appareil.</p>
    <p className="mt-1">
      {pending > 0
        ? `Vos ${pending} modification(s) non enregistrée(s) sont conservées sur cette page et sur cet appareil. Ne fermez pas cette page : reconnectez-vous dans un nouvel onglet, revenez ici puis cliquez sur « Enregistrer maintenant ».`
        : 'Aucune modification en attente. Reconnectez-vous pour continuer.'}
    </p>
    <div className="mt-2 flex flex-wrap gap-2">
      <a href="/login" target="_blank" rel="noreferrer" className="rounded bg-red-700 px-3 py-1.5 font-medium text-white" data-testid="session-lost-relogin">Se reconnecter (nouvel onglet)</a>
      {pending > 0 && (
        <>
          <button type="button" className="rounded border border-red-700 px-3 py-1.5" onClick={onRetry} data-testid="session-lost-retry">Enregistrer maintenant</button>
          <button type="button" className="rounded border border-red-300 px-3 py-1.5" onClick={() => download(schedules)} data-testid="session-lost-download">Télécharger mes saisies</button>
        </>
      )}
      <button type="button" className="ml-auto underline" onClick={onDismiss} data-testid="session-lost-dismiss">Masquer</button>
    </div>
  </div>
);
